export default __webpack_public_path__ + "static/media/drawn-highlighted-wind-turbine-icon.d6085431.svg";